import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from '../i18n/index.js';
import OnlineApp from './OnlineApp.jsx';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <I18nProvider>
    <OnlineApp />
  </I18nProvider>
);
